import React from 'react';

import Icon from 'Core/Components/Icon';
import LogoBox from 'Core/Components/LogoBox';
import Overlay from 'Core/Components/Overlay';
import ContentSectionController from 'Site/Controllers/ContentSectionController';

class Card extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    let { className, children, card } = this.props;
    className = 'Card' + (className ? ' ' + className : '');

    const { image, imagePosition, url, title, target, contain } = card;
    let { content } = card;

    if (typeof content === 'string')
      content = (<span dangerouslySetInnerHTML={{ __html: content }} />);

    return (
      <div className={className}>
        {!image ? null : (
          contain
            ? <LogoBox logo={image}/>
            : <Overlay image={image} position={imagePosition} className="card-image" />
        )}
        {!title ? null : (
          <a className={'card-title' + (url ? '' : ' dud')} target={target} href={url}>
            <span className="card-title-text">{title}</span>
          </a>
        )}
        {!content ? null : <div className="card-content">{content}</div>}
        {!children ? null : children}
      </div>
    );
  }
};

export default Card;



// WEBPACK FOOTER //
// ./client/Core/Components/Card.jsx